import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=47aaba66&scoped=true"
import script from "./usercenter.js?vue&type=script&lang=js&external"
export * from "./usercenter.js?vue&type=script&lang=js&external"
import style0 from "./usercenter.scss?vue&type=style&index=0&id=47aaba66&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aaba66",
  null
  
)

export default component.exports